<!--

	Course with its units and lessons

-->
<template>
	<div class="mia-ScopeAndSequenceCourse mia-pageBreak--before">
		<h3 class="mia-courseName">
			{{ addSpaceToFixRenderingBug(course.Name) }}
			<in-development-label-long v-if="course.InDevelopment" 
				:label-text-resource="{key:'course_in_development_tooltip'}"
				class="mia-tooltipContainer"
			/>
		</h3>
		<h5 class="mia-recommendedGrades">
			<span v-tr="'scopeandsequence_recommended_grades'" /> <span v-tr="recommendedGradeTR" />
		</h5>
		<div v-for="unit in course.Units" :key="unit.Name" class="mia-unit">
			<h4 class="mia-unitName">
				{{ addSpaceToFixRenderingBug(unit.Name) }}
			</h4>
			<div v-for="lesson in unit.Lessons" :key="lesson" class="mia-lesson">
				<h5 class="mia-lessonName">
					<text-clamp :text="addSpaceToFixRenderingBug(lesson)" auto-resize :max-lines="1"/>
				</h5>
			</div>
		</div>
	</div>
</template>
<script lang="ts">
import TextClamp from 'vue3-text-clamp';
import { DefaultText } from "@/Control/Vue/Defaults";
import I18Next from "@/Control/Vue/I18Next";
import { MiaPlaza } from "@/Reinforced.Typings";
import GradeHelper from "@/utils/GradeHelper";
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import ScopeAndSequenceControl from "./ScopeAndSequenceControl.vue";
import InDevelopmentLabelLong from "@/common/InDevelopmentLabelLong.vue";

@Component({
	components: { 
		ScopeAndSequenceControl, 
		TextClamp,
		InDevelopmentLabelLong
	},
})
export class ScopeAndSequenceCourse extends Vue {
	@Prop({required: true}) course!: MiaPlaza.LO.Curriculum.ScopeAndSequence.ICourseData;

	recommendedGradeTR = DefaultText;

	async created() {
		const [minGradeTR, maxGradeTR] = await Promise.all([
			I18Next.tr(GradeHelper.CardinalName(this.course.RecommendedGradeMin)),
			I18Next.tr(GradeHelper.CardinalName(this.course.RecommendedGradeMax))
		]);
		this.recommendedGradeTR = GradeHelper.RecommendedGradeTR(minGradeTR, maxGradeTR);
	}

	// This is a hack to fix pdf rendering bug that happens when the line starts with quote symbol: https://dev.miaplaza.com/miaplaza/website/-/issues/16145
	// It should not affect layout in any way.
	addSpaceToFixRenderingBug(str: string): string {
		return " " + str
	}
}

export default toNative(ScopeAndSequenceCourse);
</script>
<style lang="scss">
.mia-ScopeAndSequenceCourse {
	.mia-courseName {
		background-color: inherit;
		color: theme.$mia-color-themeMain;
	}

	.mia-tooltipContainer {
		display: inline-flex;
		vertical-align: middle;
	}

	.mia-label-warning {
		display: flex;
		align-items: center;
		vertical-align: middle;
		padding: theme.$mia-padding-panel-small theme.$mia-padding-panel;
		margin-bottom: theme.$mia-margin-size-small;
		
		.glyphicon {
			margin-left: theme.$mia-margin-size-small;
			font-size: theme.$font-size-base;
			top: 0;
		}
	}

	.mia-recommendedGrades {
		background-color: inherit;
		color: theme.$mia-color-ListHeaderFooter-font;
		text-transform: uppercase;
		padding-bottom: theme.$mia-padding-panel;
	}

	.mia-unit {
		padding-bottom: theme.$mia-padding-panel;
	}

	.mia-unitName, .mia-lessonName {
		margin-top: theme.$mia-margin-size-large;
		margin-bottom: theme.$mia-margin-size-large;
	}
}
</style>
